import React, { createContext, useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { get_admin_dashboard_data_api,get_artist_dashboard_data_api, get_unique_artist_data_api} from "../controllers/dataController";

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [applicationData, setApplicationData] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const [dataError, setDataError] = useState(null);

  const getAdminDashboardData = async () => {
    if (applicationData === null || applicationData.total_platforms === undefined) { // Check for a key to ensure data is loaded
      setDataLoading(true);
      try {
        let resp = await get_admin_dashboard_data_api();
        console.log("Application Data fetched:", resp);
        setApplicationData(resp);
      } catch (err) {
        setDataError({ "type": "error", "message": "Error Fetching Data" });
        console.error("Error fetching application data:", err);
      }
      setDataLoading(false);
    } else {
        console.log("Admin Dashboard Data already loaded.");
    }
  }

  const getUniqueArtistsData = async () => {
    if (applicationData === null || applicationData.artists_data === undefined) {
        setDataLoading(true); // Re-using general dataLoading for simplicity, could be separate
        try {
            const response = await get_unique_artist_data_api();
            setApplicationData(prevData => ({
                ...prevData,
                artists_data: response.artists_data
            }));
            console.log("Unique artist data received and set:", response);
        } catch (error) {
            setDataError({ "type": "error", "message": "Error Fetching Artist Data" });
            console.error("Failed to get unique artist data:", error);
        }
        setDataLoading(false);
    } else {
        console.log("Unique Artist Data already loaded.");
    }
  };

  const getArtistDashboardData = async () => {
    setDataLoading(true);
    try {
      let resp = await get_artist_dashboard_data_api();
      console.log("Application Data:", resp);
      setApplicationData(resp);
      console.log("Application Data:", applicationData);
    } catch (err) {
      setDataError({ "type": "error", "message": "Error Fetching Data" }); // Set the success state
      console.error("Error fetching application data:", err);
    }
    setDataLoading(false);
  }

  return (
    <DataContext.Provider value={{ applicationData,setApplicationData, getAdminDashboardData , getArtistDashboardData , getUniqueArtistsData, dataLoading, dataError, setDataError}}>
      {children}
    </DataContext.Provider>
  );
}